// extracted by mini-css-extract-plugin
module.exports = {"blockCompanion":"index-shimmer_blockCompanion__2sqU-","placeholderShimmer":"index-shimmer_placeholderShimmer__1-kP5"};